import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import CartDrawer from "@/components/CartDrawer";
import { CartProvider } from "@/context/CartContext";
import { ContentProvider } from "@/context/ContentContext";

import Home from "@/pages/Home";
import OrderOnline from "@/pages/OrderOnline";
import Specials from "@/pages/Specials";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Checkout from "@/pages/Checkout";
import { CheckoutSuccess, CheckoutCancel } from "@/pages/CheckoutResult";
import Admin from "@/pages/Admin";

function ScrollToTop() {
    const { pathname } = useLocation();
    React.useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
    return null;
}

function Layout({ children }) {
    const { pathname } = useLocation();
    if (pathname.startsWith("/admin")) return <>{children}</>;
    return (
        <>
            <Header />
            <main className="min-h-[70vh]">{children}</main>
            <Footer />
            <WhatsAppFloat />
            <CartDrawer />
        </>
    );
}

export default function App() {
    return (
        <div className="App bg-brand-ink min-h-screen text-brand-cream">
            <BrowserRouter>
                <ContentProvider>
                    <CartProvider>
                        <ScrollToTop />
                        <Layout>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/order" element={<OrderOnline />} />
                                <Route path="/specials" element={<Specials />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/checkout" element={<Checkout />} />
                                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                                <Route path="/checkout/cancel" element={<CheckoutCancel />} />
                                <Route path="/admin/:section?" element={<Admin />} />
                            </Routes>
                        </Layout>
                        <Toaster
                            theme="dark"
                            position="top-right"
                            toastOptions={{
                                style: {
                                    background: "#1A1A1A",
                                    border: "1px solid #2A2A2A",
                                    color: "#E8E4D9",
                                    borderRadius: "2px",
                                },
                            }}
                        />
                    </CartProvider>
                </ContentProvider>
            </BrowserRouter>
        </div>
    );
}
